import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Pagination from "../../Components/Pagination";
import Repo from "../../Utility/Repo";
import { Link } from "react-router-dom";
import ModalComponent from "../../Components/ModalComponent";
import { Input } from "design-react-kit";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import { useLocation, useHistory, useSearchParams } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListUsers() {
  const apiToken = useContext(TokenContext);
  const [usersListTemp, setUsersListTemp] = useState();
  const [usersList, setUsersList] = useState([]);
  const [isOpen, toggleModal] = useState(false);
  const [isOpenUser, toggleModalUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countUser, setCountUser] = useState(0);
  const [removableUser, setRemovableUser] = useState({});
  const [modalUser, setModalUser] = useState();

  const query = useQuery();
  const history = useHistory();

  const initialFilter = {
    firstName: query.get("firstName") || "",
    lastName: query.get("lastName") || "",
    fiscalCode: query.get("fiscalCode") || "",
    email: query.get("email") || "",
    phoneNumber: query.get("phoneNumber") || "",
    loaded: query.get("loaded") === "true", // Converti in booleano
  };

  const [filter, setFilter] = useState(initialFilter);

  const fetchUsers = (filter) => {
    setLoading(true);
    Repo.getUsersList(apiToken, filter)
      .then((response) => {
        setUsersListTemp(response.data);
        setCountUser(response.data.count);
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (filter.loaded) {
      fetchUsers(filter);
    }
  }, []); // Effettua una ricerca al caricamento della pagina

  const sendFilter = () => {
    history.push(
      `?firstName=${filter.firstName}&lastName=${filter.lastName}&fiscalCode=${filter.fiscalCode}&email=${filter.email}&phoneNumber=${filter.phoneNumber}&loaded=${filter.loaded}`
    );
    fetchUsers(filter);
  };

  const clearFilter = () => {
    const resetFilter = {
      firstName: "",
      lastName: "",
      fiscalCode: "",
      email: "",
      phoneNumber: "",
      loaded: false,
    };

    setFilter(resetFilter);

    // Esegue una ricerca con tutti i campi vuoti
    fetchUsers(resetFilter);
  };

  const removeUserAPI = () => {
    Repo.postDeleteUser(apiToken, removableUser.id)

      .then((response) => {
        if (response.status == 204) {
          setRemovableUser({});
          window.location.href = props.subfolder + "/lista_utenti";
        }
      })
      .catch((error) => {
        setRemovableUser({});
        console.log(error);
      });
  };

  const filterOnLoad = (myObj) => {
    Repo.getUsersList(apiToken, myObj)
      .then((response) => {
        setUsersListTemp(response.data);
        setCountUser(response.data.count);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Previene il comportamento predefinito
      sendFilter(); // Esegue la ricerca
    }
  };

  useEffect(() => {
    setLoading(true);

    var paramLoaded = query.get("loaded");

    if (paramLoaded == "true") {
      const myObj = {
        loaded: true,
      };
      filterOnLoad(myObj);
      setFilter({ ...filter, loaded: true });
    } else {
      sendFilter();
    }

    setLoading(false);
  }, []);

  return (
    <>
      <div>
        <h1>Lista utenti</h1>
        <div className="row">
          <div className="clearfix col-lg-8 py-lg-2">
            <p>
              Tutti gli utenti caricati sul sistema. Da qui è possibile cercare
              un utente o aggiungere un nuovo utente.{" "}
            </p>
          </div>

          <div className="col-lg-4 clearfix">
            <button
              type="button"
              className="btn btn-outline-success float-right p-2"
              onClick={() =>
                (window.location.href =
                  window.location.pathname + "/nuovo_utente")
              }
            >
              <svg className="icon icon-success">
                <use href={`${iconSprite}#it-plus-circle`} />
              </svg>{" "}
              <span className="align-middle">Nuovo Utente</span>
            </button>
          </div>
        </div>

        {/*Inizo cerca*/}

        {/*Inizo cerca*/}
        <div className="row" onKeyDown={handleKeyDown}>
          <div className="form-group col-md-4">
            <Input
              id="first_name"
              required
              label="Nome"
              type="text"
              name="first_name"
              value={filter.firstName} // Aggiunto il valore
              autoComplete="off"
              onChange={(e) =>
                setFilter({ ...filter, firstName: e.target.value })
              }
            />
          </div>
          <div className="form-group col-md-4">
            <Input
              id="last_name"
              required
              label="Cognome"
              type="text"
              name="last_name"
              value={filter.lastName} // Aggiunto
              autoComplete="off"
              onChange={(e) =>
                setFilter({ ...filter, lastName: e.target.value })
              }
            />
          </div>
          <div className="form-group col-md-4">
            <Input
              id="fiscal_code"
              required
              label="Codice Fiscale"
              type="text"
              name="fiscal_code"
              value={filter.fiscalCode} // Aggiunto
              autoComplete="off"
              onChange={(e) =>
                setFilter({ ...filter, fiscalCode: e.target.value })
              }
            />
          </div>

          <div className="form-group col-md-4">
            <Input
              id="email"
              required
              label="Email"
              type="text"
              name="email"
              value={filter.email} // Aggiunto
              autoComplete="off"
              onChange={(e) => setFilter({ ...filter, email: e.target.value })}
            />
          </div>
          <div className="form-group col-md-3">
            <Input
              id="phone_number"
              required
              label="Telefono"
              type="text"
              name="phone_number"
              value={filter.phoneNumber} // Aggiunto
              autoComplete="off"
              onChange={(e) =>
                setFilter({ ...filter, phoneNumber: e.target.value })
              }
            />
          </div>

          <div className="form-group col-md-2 text-center">
            <div className="form-check">
              <input
                id="chkValidUserStatus"
                type="checkbox"
                checked={filter.loaded}
                onChange={(e) =>
                  setFilter({ ...filter, loaded: e.target.checked })
                }
              />
              <label htmlFor="chkValidUserStatus">Da validare</label>
            </div>
          </div>

          <div className="form-group col-md-3 text-right">
            <button
              type="button"
              className="btn btn-outline-primary m-2"
              onClick={clearFilter}
            >
              Annulla
            </button>

            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={sendFilter}
            >
              Cerca
            </button>
          </div>
        </div>

        {/*Fine cerca*/}
        <div className="row float-end">
          <strong>
            Utenti trovati:{" "}
            <span className="badge rounded-pill bg-primary text-white">
              {usersListTemp?.length || 0}
            </span>{" "}
          </strong>
        </div>

        {usersList && usersList.length > 0 && (
          <table className="table mt-3">
            <thead>
              <tr>
                <th scope="col">Codice Fiscale</th>
                <th scope="col">Nome</th>
                <th scope="col">Cognome</th>

                <th scope="col" className="text-center">
                  Ultimo ISEE
                </th>
                <th scope="col" alt="Data registrazione">
                  Data reg.
                </th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {usersList.map((x, index) => (
                <React.Fragment key={index}>
                  <tr
                    className={`${
                      x.state === "LOADED"
                        ? "table-success"
                        : x.state === "SUSPEND"
                        ? "table-secondary"
                        : ""
                    }`}
                  >
                    <th scope="row">{x.fiscalCode}</th>
                    <td>{x.firstName}</td>
                    <td>{x.lastName}</td>
                    <td className="text-right">
                      {x.isees.length > 0 ? (
                        <>
                          {x.isees[x.isees.length - 1].value !== null && (
                            <>
                              <span>
                                {parseFloat(
                                  x.isees[x.isees.length - 1].value
                                ).toLocaleString("it-IT")}{" "}
                                € (<b>{x.isees[x.isees.length - 1].year}</b>)
                              </span>
                              <br />

                              {x.isees[x.isees.length - 1].state ===
                              "VALIDATED" ? (
                                <b className="text-success">
                                  <span
                                    className="icon-wrapper"
                                    title="Validato"
                                  >
                                    <svg className="icon icon-success">
                                      <use
                                        href={`${iconSprite}#it-check-circle`}
                                      ></use>
                                    </svg>
                                  </span>
                                </b>
                              ) : x.isees[x.isees.length - 1].state ===
                                "LOADED" ? (
                                <b className="text-success">
                                  <span
                                    className="icon-wrapper"
                                    title="Caricato"
                                  >
                                    <svg className="icon icon-warning">
                                      <use
                                        href={`${iconSprite}#it-warning`}
                                      ></use>
                                    </svg>
                                  </span>
                                </b>
                              ) : x.isees[x.isees.length - 1].state ===
                                "REFUSED" ? (
                                <b className="text-success">
                                  <span
                                    className="icon-wrapper"
                                    title="Rifiutato"
                                  >
                                    <svg className="icon icon-danger">
                                      <use
                                        href={`${iconSprite}#it-error`}
                                      ></use>
                                    </svg>
                                  </span>
                                </b>
                              ) : (
                                x.isees[x.isees.length - 1].state
                              )}
                              {x.isees[x.isees.length - 1].hasFile === true ? (
                                <b className="text-success">
                                  <span title="Allegato caricato">
                                    <svg className="icon icon-secondary">
                                      <use href={`${iconSprite}#it-file`}></use>
                                    </svg>
                                  </span>
                                </b>
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>N/A</>
                      )}
                    </td>
                    <td>{x.dataInsert}</td>
                    <td className="text-right">
                      <Link to={"/lista_utenti/dati_utente?citizen=" + x.id}>
                        <button
                          className="btn btn-outline-primary p-1"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Dettaglio"
                        >
                          <svg className="icon icon-primary">
                            <use href={`${iconSprite}#it-search`} />
                          </svg>
                        </button>
                      </Link>
                      {x.isees.length > 0 ? (
                        <button
                          className="btn btn-outline-secondary disabled p-1 ml-1"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Non è possibile cancellare un utente se ha dati collegati!"
                        >
                          <svg className="icon icon-secondary">
                            <use href={`${iconSprite}#it-delete`} />
                          </svg>
                        </button>
                      ) : (
                        <button
                          className="btn btn-outline-danger p-1 ml-1"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="È possibile eliminare l'utente solo se non ha caricato ISEE"
                          onClick={() => {
                            toggleModal(!isOpen);
                            setRemovableUser({
                              firstName: x.firstName,
                              lastName: x.lastName,
                              id: x.id,
                            });
                          }}
                        >
                          <svg className="icon icon-danger">
                            <use href={`${iconSprite}#it-delete`} />
                          </svg>
                        </button>
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        )}

        {usersListTemp && (
          <Pagination
            items={usersListTemp}
            setCurrentItems={setUsersList}
            itemsPerPage={15}
          ></Pagination>
        )}
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header={
          "Rimozione utente: " +
          removableUser.firstName +
          " " +
          removableUser.lastName
        }
        body={
          "Confermi di voler rimuovere " +
          removableUser.firstName +
          " " +
          removableUser.lastName +
          "?"
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => removeUserAPI()}
      ></ModalComponent>

      {loading && <Loader></Loader>}
    </>
  );
}

export default ListUsers;
